import { gql, TypedDocumentNode } from '@apollo/client';
import { Gender } from '../../generated/types';

export type EmailSubscribeMutation = {
  emailSubscribe: {
    __typename: 'RestEmailSubscribePayload';
    table: {
      __typename: 'RestEmailSubscribeTable';
      isExistingSubscription: boolean;
    };
  };
};

export type Placement =
  | 'footer'
  | 'emailPumoModule'
  | 'welcomePopup'
  | 'productDetails'
  | 'smsPumoModule'
  | 'trunkshow';

export type SignUpSource = 'mobile' | 'desktop' | 'beauty';

type CommonEmailSubscribeMutationVariables = {
  input: {
    user: {
      email: string;
      gender: Gender;
      phone: string;
    };
    label: Placement;
    category: string;
    sign_up_source_target: SignUpSource;
  };
};

export type NewsletterEmailSubscribeMutationVariables = CommonEmailSubscribeMutationVariables;

export type DesignerEmailSubscribeMutationVariables = CommonEmailSubscribeMutationVariables & {
  input: {
    label: Placement;
    category: string;
    entity_id: number;
    entity_type: 'Trunkshow';
    trunkshow_preview: true;
  };
};

export type EmailSubscribeMutationVariables =
  | NewsletterEmailSubscribeMutationVariables
  | DesignerEmailSubscribeMutationVariables;

export const EMAIL_SUBSCRIBE_MUTATION: TypedDocumentNode<
  EmailSubscribeMutation,
  EmailSubscribeMutationVariables
> = gql`
  mutation EmailSubscribeMutation($input: EmailSubscribeMutationVariables!) {
    emailSubscribe(input: $input)
      @rest(
        type: "RestEmailSubscribePayload"
        path: "/v3.5/users/set_email_newsletter_preferences"
        method: "POST"
      ) {
      table @type(name: "RestEmailSubscribeTable") {
        isExistingSubscription: is_existing_subscription
      }
    }
  }
`;
